import {isNumeric} from '../../util/helpers';

export class ReviewSubrating {
  /**
   * Name of subrating average refers to
   */
  feature: string;

  /**
   * Avergage rating for this feature of this entity
   */
  rating: number;

  /**
   * Parses reviewSubrating
   * @param data {any} ReviewSubrating data as returned by API
   * @return {ReviewSubrating} Parsed ReviewSubrating
   */
  static parse(data: any): ReviewSubrating {
    return {
      feature: data.feature,
      rating: isNumeric(data.rating) ? +data.rating : null
    };
  }
}
